var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTickSort(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "8px",
    viewBox: "0 0 10 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icTickSort") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M98.7733333,13.6355556 C98.7022222,13.5662222 98.6666667,13.4622222 98.6666667,13.3928889 C98.6666667,13.3235556 98.7022222,13.2195556 98.7733333,13.1502222 L99.2711111,12.6648889 C99.4133333,12.5262222 99.6266667,12.5262222 99.7688889,12.6648889 L99.8044444,12.6995556 L101.76,14.7448889 C101.831111,14.8142222 101.937778,14.8142222 102.008889,14.7448889 L106.773333,9.92622222 L106.808889,9.92622222 C106.951111,9.78755556 107.164444,9.78755556 107.306667,9.92622222 L107.804444,10.4115556 C107.946667,10.5502222 107.946667,10.7582222 107.804444,10.8968889 L102.115556,16.6515556 C102.044444,16.7208889 101.973333,16.7555556 101.866667,16.7555556 C101.76,16.7555556 101.688889,16.7208889 101.617778,16.6515556 L98.8444444,13.7395556 L98.7733333,13.6355556 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter-Views-",
    transform: "translate(-197.000000, -512.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Date-joined-Copy-2",
    transform: "translate(99.000000, 503.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icTickSort",
    fill: "#333333",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTickSort);
export default __webpack_public_path__ + "static/media/icTickSort.311b68f116df95fc75a3b44b014305be.svg";
export { ForwardRef as ReactComponent };